var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary-table"},[_c('table-component',{attrs:{"data":_vm.chapters,"sort-by":"pubdate","sort-order":"desc"},on:{"rowClick":_vm.dataTableClick}},_vm._l((_vm.colKeys),function(col){return _c('table-column',_vm._b({key:col.title},'table-column',col,false))}))],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ecdd18b","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SummaryTable.vue
// module id = 2856
// module chunks = 1